<h1 class="accent-background-element">Review User</h1>

<mat-dialog-content>
  <h3>Role: <span class="not-bold">{{currentUser?.role}}</span></h3>
  <h3>Full Name: <span class="not-bold">{{currentUser?.firstName}} {{currentUser?.lastName}}</span></h3>
  <h3>E-mail: <span class="not-bold">{{currentUser?.email}}</span></h3>
  <h3>Country: <span class="not-bold">{{currentUser?.country}}</span></h3>

  @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
    <div>
      <h3>Clinic: <span class="not-bold">{{[currentClinic?.clinicId, currentClinic?.clinicName,
      currentClinic?.addressLine1,currentClinic?.addressLine2].join(', ')}}</span></h3>
      <h3>Clinic List: <span class="not-bold">{{currentClinicList.join(', ')}}</span></h3>
    </div>
  }
  @if (currentUser?.role==UserRolesEnum.ent) {
    <div>
      <h3>ENT Office: <span class="not-bold">{{[currentOffice?.entOfficeId, currentOffice?.entOfficeName,
      currentOffice?.addressLine1,currentOffice?.addressLine2].join(', ')}}</span></h3>
    </div>
  }
  <h3>Language: <span class="not-bold">{{currentUser?.lang}}</span></h3>

  @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
    <h3> Shop Manager: <span class="not-bold">{{currentUser?.shopAdminAccess? 'Yes':'No'}}</span></h3>
  }
  @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
    <h3> Country Manager: <span class="not-bold">{{currentUser?.countryShopsAccess? 'Yes':'No'}}</span></h3>
  }
  @if (currentUser?.role!=UserRolesEnum.ent && currentUser?.role!=UserRolesEnum.dal) {
    <h3> Patient Manager: <span class="not-bold">{{currentUser?.patientManagerAccess? 'Yes':'No'}}</span></h3>
  }
  @if ( currentUser?.role!=UserRolesEnum.dal) {
    <h3> Advanced Dashboard User: <span class="not-bold">{{currentUser?.advancedMode? 'Yes':'No'}}</span></h3>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="accent" (click)="goBack()">Go back</button>
  <span class="spacer"></span>
  <button mat-raised-button color="accent" (click)="onSubmit()">Continue</button>
</mat-dialog-actions>